import { Add as AddIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import React from 'react'

type Props = { onClick: () => void }

export const AddRowButton: React.FC<Props> = ({ onClick }) => (
	<Button size="small" startIcon={<AddIcon />} onClick={onClick}>
		Add
	</Button>
)
